// Shared axios instance for the handful of services that need raw axios
// (multipart uploads, blob downloads) instead of the fetch-based apiClient.
// Centralizes what commonService/referenceFileService/chatService used to
// each do by hand (attach the token, build the full URL) and - the actual
// point of consolidating them - gives one place to react to an expired
// token instead of every call site needing its own check.
import axios from 'axios';
import { API_CONFIG } from '../utils/constants';
import { handleSessionExpired } from '../utils/sessionExpiry';

export const httpClient = axios.create({
  baseURL: API_CONFIG.BASE_URL,
});

httpClient.interceptors.request.use((config) => {
  const token = localStorage.getItem('accessToken');
  if (token) {
    config.headers = config.headers || {};
    (config.headers as Record<string, string>).Authorization = `Bearer ${token}`;
  }
  return config;
});

httpClient.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error?.response?.status === 401) handleSessionExpired();
    return Promise.reject(error);
  }
);

export default httpClient;
